import { useMutation } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';

interface CreateRatingParams {
  number: number;
  comment?: string;
}

export function useCreateRating() {
  const { axiosInstance } = useApi();

  return useMutation({
    mutationFn: async (params: CreateRatingParams) => {
      const { data } = await axiosInstance.post('/api/v1/ratings', {
        rating: params,
      });
      return data;
    },
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: ["ratings"] });
    },
  });
}
